import Login from './Login';
import ForgetPassword from './ForgetPassword';
import Page404 from './Page404';
import Page500 from './Page500';
import Register from './Register';

export {
  Login, ForgetPassword, Page404, Page500, Register
};



// WEBPACK FOOTER //
// ./src/views/Pages/index.js